import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

const PasswordInput = ({
  name,
  control,
  label,
  placeholder,
  rules = {},
  onValueChange,
  className = {},
}) => {
  const [visible, setVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setVisible(!visible);
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => (
        <>
          <input
            id={`password-${name}`}
            type={visible ? "text" : "password"}
            value={value || ""}
            onChange={(e) => {
              onChange(e.target.value);
              onValueChange && onValueChange(e.target.value);
            }}
            onBlur={onBlur}
            placeholder={placeholder}
            className={className}
          />
          {label && (
            <label
              htmlFor={`password-${name}`}
              className="text-body-b2 input-password-label"
            >
              {label}
            </label>
          )}

          <button
            type="button"
            className="password-toggle"
            aria-label="Toggle password visibility"
            onClick={togglePasswordVisibility}
          >
            <img
              src="/icons/password-eye-open.svg"
              className="eye-open"
              alt=""
              style={{ display: visible ? "none" : "block" }}
            />
            <img
              src="/icons/password-eye-off-icon.svg"
              className="eye-closed"
              alt=""
              style={{ display: visible ? "block" : "none" }}
            />
          </button>
        </>
      )}
    />
  );
};

export default PasswordInput;
